<template>
    <div class="Input InputSelect">
        <el-select
            :name="'input-' + name"
            v-model="localModel"
            :placeholder="placeholder"
            :class="{ error: localErrors.length }"
            v-on:blur="onBlur()"
            :automatic-dropdown="true"
        >
            <el-option v-if="key != '_config'"
                             v-for="label, key in items"
                             :label="key"
                             :key="key"
                             :value="key"/>
        </el-select>
        <div v-if="errors" class="Input__error">{{localErrors[0]}}</div>
    </div>
</template>

<style lang="sass">
    @import ../../../common/styles/mixins
    @import ../../../common/styles/settings

    .InputSelect
        position: relative

        .el-select
            width: 100%
            &.error
                .el-input__inner
                    border: 1px solid $color-base

            .el-input__inner
                background: none
                border: 0
                border-bottom: 1px solid $color-text
                border-radius: 0
                padding: 0 0 1rem
                font-family: Roboto, sans-serif
                font-size: 14px
                font-weight: 400
                &::-webkit-input-placeholder
                    color: transparentize($color-text, 0.2)

            .el-input.is-focus .el-input__inner
                border-color: $color-gray-medium


            .el-select__caret
                font-size: 1.25rem

    .el-popper
        margin: 0 !important
        .popper__arrow
            display: none !important


    .el-select-dropdown
        border: 0
        background-color: $color-gray-light
        +media("<768px")
            width: 90%
            left: 5% !important
        &__list
            max-height: 300px
            overflow-y: scroll

    .el-select-dropdown__wrap
        max-height: none
        background-color: $color-white

    .el-scrollbar__view
        li
            height: auto
            white-space: inherit
            line-height: 1
            margin-top: 0 !important
            margin-bottom: 0 !important
            padding-top: 0.5rem !important
            padding-bottom: 0.5rem !important
            border: 0 !important
            font-size: 16px

    .el-select-dropdown__item
        color: $color-text
        &.hover,
        &:hover
            background-color: rgba(206, 14, 74, 0.15)
            color: $color-text




</style>

<script>

    export default {
        props: ["name", "value", "items", "placeholder", "errors"],
        data() {
            return {
                localModel: this.value,
                localErrors: this.errors || []
            }
        },
        mounted() {
          // Prevent the open/close effect on first click
          window.firstClick = true;
          jQuery('.InputSelect').find('input').on('click', function(e) {
              if (jQuery(this).parent().hasClass('is-focus') && window.firstClick) {
                  e.preventDefault();
                  e.stopPropagation();
                  window.firstClick = false;
              }
          })
        },
        watch: {
            localModel(val) {
                this.$emit("input", val);
                this.$parent.validateField(this.name);
            },
            value: function(newVal, oldVal) {
                this.localModel = newVal;
                if (this.name === 'secteurActivite' && newVal === 'VTC') {
                    jQuery(this.$el).closest('.node-contact__wrapper').next('.node-contact__info').find('a.button').focus();
                }
            },
            errors: function(newVal, oldVal) {
                this.localErrors = newVal || [];
            }
        },
        methods: {
            onBlur: function() {
                this.$parent.validate();
                window.firstClick = true;
            }
        }
    }

</script>
